import { CityCountryPair } from "../api";
import { getCountryName } from "./countryNames.ts";

export const cityCountryPairLabel = (
  value: CityCountryPair,
  { long }: { long?: boolean } = {},
) => `${value.city}, ${long ? getCountryName(value.country) : value.country}`;

export const cityCountryPairValue = (value: CityCountryPair) => {
  if (!value.country || value.country.length != 2) {
    return value.city;
  }
  return `${value.city}:${value.country}`;
};

export const parseCityCountryPairValue = (value: string): CityCountryPair => {
  if (value.substring(value.length - 3, value.length - 2) == ":") {
    return {
      city: value.substring(0, value.length - 3),
      country: value.substring(value.length - 2),
    };
  }
  return {
    city: value,
    country: "",
  };
};
